import _ from "lodash";
export const getIsAIGeneratingResponseForTool = ({
  state,
  studentAssignmentId,
  assessmentFields,
}) => {
  const isAiGradingEvaluationEnabled = _.get(
    _.find(assessmentFields, { uid: "aiEvaluation" }),
    "value",
    false
  );

  const studentsAIGradingProgress = _.get(
    state,
    "classRoom.aiGradingProgress",
    {}
  );

  const aiGradingProgressValue = studentsAIGradingProgress[studentAssignmentId];

  return (
    isAiGradingEvaluationEnabled &&
    aiGradingProgressValue &&
    aiGradingProgressValue < 100
  );
};
